import {mergeWith} from 'lodash';
import * as lcfirst from 'lcfirst';
import i18n from '../../i18n';
import moment from 'moment';
import swal from 'sweetalert';

export const mergeWithDefault = (values, defaultValues) => (
    mergeWith(defaultValues, values, (a, b) => b === null ? a : undefined)
);

/**
 * Show company name or first + last name of contact. If null returns default
 * @param {contact} contact
 * @param {string} def
 * @returns {string}
 */
export const getContactName = (contact, def = '') => {
    return contact ? (contact.is_company ? contact.company_name : contact.first_name + ' ' + contact.last_name) : def;
};

export const getSelectContactOption = (entity) => {
    return getSelectOption(entity['id'], getContactName(entity), entity);
};

export const getCategoryOption = (category, categoryOptions) => {
    let filtered = categoryOptions.filter((item) => item.value === category);
    if (filtered && filtered.length > 0) {
        return filtered.shift();
    }
    return null;
};

export const getMutationName = (mutation) => {
    return lcfirst(mutation && mutation.definitions && mutation.definitions[0] && mutation.definitions[0].name && mutation.definitions[0].name.value);
};
export const getQueryName = (query) => {
    return lcfirst(query && query.definitions && query.definitions[0] && query.definitions[0].name && query.definitions[0].name.value);
};
export const getSelectOption = (value, label, entity) => {
    return {value, label, entity};
};
export const getSelectOptionEntity = (entity, labelName, valueName) => {
    return getSelectOption(entity[valueName || 'id'], entity[labelName || 'name'], entity);
};
export const setNameWithLabel = (data, label) => {
    data[label || 'name'] = [data.company_name, data.first_name, ' ', data.last_name].join('').trim();
    return data;
};
export const getBuildingOptions =  (data, label) => {
    data[label || 'code'] = [data.city, ', ',data.street,' ', data.number].join('').trim();
    return data;
}

export const swalCancelConfirm = () => {
    return {
        buttons: [
            i18n.get('default.cancel'),
            i18n.get('default.confirm'),
        ],
    };
};

export const swalCancelDelete = () => {
    return {
        buttons: [
            i18n.get('default.cancel'),
            i18n.get('default.delete'),
        ],
    };
};

export const swalFailed = (action) => {
    swal({
        text: i18n.get('default.ajax_error'),
        icon: 'error',
    }).then(() => {
        if (action) {
            action();
        }
    });
};

export const DateParse = (value, defaultValue) => {
    let value_try = moment(value);
    if (value_try.isValid()) {
        return value_try;
    }

    value_try = moment(value, 'DD.MM.YYYY hh:mm:ss');
    if (value_try.isValid()) {
        return value_try;
    }
    value_try = moment(value, 'DD.MM.YYYY hh:mm');
    if (value_try.isValid()) {
        return value_try;
    }
    value_try = moment(value, 'DD.MM.YYYY');
    if (value_try.isValid()) {
        return value_try;
    }
    value_try = moment(value, 'YYYY-MM-DD hh:mm:ss');
    if (value_try.isValid()) {
        return value_try;
    }
    value_try = moment(value, 'YYYY-MM-DD hh:mm');
    if (value_try.isValid()) {
        return value_try;
    }
    value_try = moment(value, 'YYYY-MM-DD');
    if (value_try.isValid()) {
        return value_try;
    }
    return defaultValue;
};

export const DateToString = (value, format) => {
    let dt = DateParse(value);
    if (dt) {
        return dt.format(format || 'DD.MM.YYYY hh:mm');
    }
    return '';
};

export const calculateDate = (start, operation, difference, unit) => {
    start = moment(start);
    difference = difference || 7;
    unit = unit || 'days'
    let calculated;
    if(operation === 'subtract') {
        calculated = start.subtract(difference, unit);
    } else if(operation === 'add') {
        calculated = start.add(difference, unit);
    } else {
        calculated = start;
    }
    return calculated.format('YYYY-MM-DD');
}

export const urlQuery = (params) => {
    return Object.keys(params).map(key => params[key] ? key + '=' + params[key] : null).filter(() => true).join('&');
};

export const states = () => {
    return ([
        {value: 'DE-BW', label: i18n.get('culture.states.de_bw')},
        {value: 'DE-BY', label: i18n.get('culture.states.de_by')},
        {value: 'DE-BE', label: i18n.get('culture.states.de_be')},
        {value: 'DE-BB', label: i18n.get('culture.states.de_bb')},
        {value: 'DE-HB', label: i18n.get('culture.states.de_hb')},
        {value: 'DE-HH', label: i18n.get('culture.states.de_hh')},
        {value: 'DE-HE', label: i18n.get('culture.states.de_he')},
        {value: 'DE-MV', label: i18n.get('culture.states.de_mv')},
        {value: 'DE-NI', label: i18n.get('culture.states.de_ni')},
        {value: 'DE-NW', label: i18n.get('culture.states.de_nw')},
        {value: 'DE-RP', label: i18n.get('culture.states.de_rp')},
        {value: 'DE-SL', label: i18n.get('culture.states.de_sl')},
        {value: 'DE-SN', label: i18n.get('culture.states.de_sn')},
        {value: 'DE-ST', label: i18n.get('culture.states.de_st')},
        {value: 'DE-SH', label: i18n.get('culture.states.de_sh')},
        {value: 'DE-TH', label: i18n.get('culture.states.de_th')},
    ]);
}

export const relations = () => {
    return ([
        {value:'builder', label:i18n.get('contacts.relation.constructor')},
        {value:'subcontractor', label:i18n.get('contacts.relation.subcontractor')},
    ]);
};

//  random hex string generator
export const randHex = (len) => {
    let maxLen = 8,
        min = Math.pow(16,Math.min(len,maxLen)-1),
        max = Math.pow(16,Math.min(len,maxLen)) - 1,
        n   = Math.floor( Math.random() * (max-min+1) ) + min,
        r   = n.toString(16);
    while ( r.length < len ) {
        r = r + randHex( len - maxLen );
    }
    return r;
}

const vowelMap = {
    '\u00dc': 'UE',
    '\u00c4': 'AE',
    '\u00d6': 'OE',
    '\u00fc': 'ue',
    '\u00e4': 'ae',
    '\u00f6': 'oe',
    '\u00df': 'ss',
}

// replace all german vowels from a string
export const replaceVowels = (str) => {
    return str
        .replace(/[\u00dc|\u00c4|\u00d6][a-z]/g, (a) => {
            const big = vowelMap[a.slice(0, 1)];
            return big.charAt(0) + big.charAt(1).toLowerCase() + a.slice(1);
        })
        .replace(new RegExp('['+ Object.keys(vowelMap).join('|') + ']',"g"),
            (a) => vowelMap[a]
        );
}

export const cleanPhone = (phone) => {
    let num = phone.match(/[\d\\+]+/g);
    return num ? num.join('').replace('+', '00') : '';
};

// https://www.nayuki.io/page/knuth-morris-pratt-string-matching
export const matchString = (pattern, text) => {
    if (pattern.length === 0)
        return 0; // Immediate match

    // Compute longest suffix-prefix table
    let lsp = [0]; // Base case
    for (let i = 1; i < pattern.length; i++) {
        let j = lsp[i - 1]; // Start by assuming we're extending the previous LSP
        while (j > 0 && pattern.charAt(i) !== pattern.charAt(j))
            j = lsp[j - 1];
        if (pattern.charAt(i) === pattern.charAt(j))
            j++;
        lsp.push(j);
    }

    // Walk through text string
    let j = 0; // Number of chars matched in pattern
    for (let i = 0; i < text.length; i++) {
        while (j > 0 && text.charAt(i) !== pattern.charAt(j))
            j = lsp[j - 1]; // Fall back in the pattern
        if (text.charAt(i) === pattern.charAt(j)) {
            j++; // Next char matched, increment position
            if (j === pattern.length)
                return i - (j - 1);
        }
    }
    return -1; // Not found
}
